import axios from 'axios';
import lib from '@/lib';

export default class AuthModel {
	constructor() {
		this.authChecked = false;
		this.token = lib.localStorageGet('token')||'';
		this.refresh_token = lib.localStorageGet('refresh_token')||'';
		this.device_id = lib.localStorageGet('device_id')||'';
		
		this.userProfile = null;
		this.userPermissions = [];
		this.userKeychains = [];
		this.userAccounts = [];
		
		if (this.token) {
			axios.defaults.headers.common['Authorization'] = `Bearer ${this.token}`;
		}
		if (this.refresh_token) {
			axios.defaults.headers.common['Refresh-Token'] = this.refresh_token;
		}
		if (this.device_id) {
			axios.defaults.headers.common['Device-ID'] = this.device_id;
		}
		axios.defaults.headers.common['Content-Type'] = 'application/json';
	}
	
	/**
	 * Инициализация данных пользователя
	 */
	async doInitData() {
		if (!this.authChecked && this.token) {
			try {
				const response = await axios.get('https://id.bylex.su/api/user/get-init-data', {
					mode: 'cors',
					cache: 'no-cache',
					withCredentials: true,
				});
				this.setUserProfile(response.data.user_data);
				this.userPermissions = response.data.user_permissions || [];
				this.userKeychains = response.data.user_keychains || [];
				this.userAccounts = response.data.user_accounts || [];
				this.authChecked = true;
			} catch (error) {
				console.error(error);
				if (error.response) {
					return {
						success: false,
						...error.response.data,
					};
				} else {
					return {
						success: false,
						error: error.message,
					};
				}
			}
		}
		return {
			success: true,
		};
	}
	
	/**
	 * Продление токена
	 */
	async doRefreshToken() {
		const refresh_token = this.refresh_token;
		try {
			const response = await axios.post('https://id.bylex.su/api/auth/refresh-token', {}, {
				mode: 'cors',
				cache: 'no-cache',
				withCredentials: true,
				headers: {
					'Refresh-Token': refresh_token,
				}
			});
			const newToken = response.data.token;
			this.token = newToken;
			lib.localStorageSet('token', newToken, 0);
			axios.defaults.headers.common['Authorization'] = `Bearer ${newToken}`;
			return newToken;
		} catch (error) {
			console.error('Ошибка обновления токена:', error);
			this.token = '';
			this.refresh_token = '';
			lib.localStorageRemove('token');
			lib.localStorageRemove('refresh_token');
			delete axios.defaults.headers.common['Authorization'];
			delete axios.defaults.headers.common['Refresh-Token'];
			throw error;
		}
	}
	
	/**
	 * Проверка токена на наличие в черном списке
	 */
	async doCheckTokenBlacklist(token) {
		try {
			const response = await axios.post('https://id.bylex.su/api/auth/check-token-blacklist', {
				token,
			}, {
				mode: 'cors',
				cache: 'no-cache',
				withCredentials: true,
			});
			return response.data.blacklisted;
		} catch (error) {
			console.error('Ошибка проверки черного списка', error);
			return false; // Предположим, что токен не в черном списке при ошибке
		}
	}
	
	/**
	 * Проверка сессии на ее существование
	 */
	async doCheckSession() {
		try {
			const response = await axios.post('https://id.bylex.su/api/auth/check-session', {
				user_id: this.getUserId(),
				device_id: this.device_id,
			}, {
				mode: 'cors',
				cache: 'no-cache',
				withCredentials: true,
			});
			return response.data.valid;
		} catch (error) {
			console.error('Ошибка проверки сессии', error);
			return false; // Предположим, что токен не в черном списке при ошибке
		}
	}
	
	/**
	 * Деавторизация
	 */
	async doLogout() {
		try {
			await axios.post('https://id.bylex.su/api/auth/logout', {}, {
				mode: 'cors',
				cache: 'no-cache',
				withCredentials: true,
			});
			this.userProfile = null;
			this.userPermissions = [];
			this.userKeychains = [];
			this.userAccounts = [];
			lib.localStorageRemove('token');
			lib.localStorageRemove('refresh_token');
			this.token = '';
			this.refresh_token = '';
			delete axios.defaults.headers.common['Authorization'];
			delete axios.defaults.headers.common['Refresh-Token'];
			this.authChecked = false;
			return true;
		} catch (error) {
			console.error(error);
			this.userProfile = null;
			this.userPermissions = [];
			this.userKeychains = [];
			this.userAccounts = [];
			lib.localStorageRemove('token');
			lib.localStorageRemove('refresh_token');
			this.token = '';
			this.refresh_token = '';
			delete axios.defaults.headers.common['Authorization'];
			delete axios.defaults.headers.common['Refresh-Token'];
			this.authChecked = false;
			return false;
		}
	}
	
	isAuth() {
		return this.token != '' && this.userProfile != null;
	}
	
	getVirtualSpaces() {
		return this.userAccounts.filter((el) => el.virtualspace_id != null);
	}
	
	/**
	 * Получение виртуального пространства по его id
	 */
	getVirtualSpace(id) {
		return this.userAccounts.find((el) => el.virtualspace_id == id);
	}
	
	getUserId() {
		return this.userProfile != null ? this.userProfile.user_id : '';
	}
	
	getLogin() {
		return this.userProfile != null ? this.userProfile.login : '';
	}
	
	getSname() {
		return this.userProfile != null ? this.userProfile.sname : '';
	}
	
	getFname() {
		return this.userProfile != null ? this.userProfile.fname : '';
	}
	
	getLname() {
		return this.userProfile != null ? this.userProfile.lname : '';
	}
	
	getGender() {
		return this.userProfile != null ? this.userProfile.gender : '';
	}
	
	getDateOfBirth() {
		return this.userProfile != null ? this.userProfile.dateofbirth : '';
	}
	
	getEmail() {
		return this.userProfile != null ? this.userProfile.email : '';
	}
	
	getAvatarLink() {
		return this.userProfile != null ? 'https://id.bylex.su' + this.userProfile.ava : '';
	}
	
	isAdmin() {
		return this.hasPermission('account.bylex.superadmin');
	}
	
	hasPermission(permission_api_name, virtualspace_id = null)  {
		if (Object.values(this.userPermissions).length > 0) {
			if (virtualspace_id) {
				return !!(Object.values(this.userPermissions).find(elem => elem.virtualspace_id == virtualspace_id && elem.permissions.includes(permission_api_name)));
			} else {
				return !!(Object.values(this.userPermissions).find(elem => elem.permissions.includes(permission_api_name)));
			}
		}
		return false;
	}
	
	/**
	 * Устанавливает user profile
	 */
	setUserProfile(res) {
		if (res == null) {
			this.userProfile = null;
		} else {
			this.userProfile = {
				user_id: res.id,
				login: res.login,
				sname: res.sname,
				fname: res.fname,
				lname: res.lname,
				gender: res.gender,
				dateofbirth: res.dateofbirth,
				email: res.email,
				ava: res.avatar,
			};
		}
	}
}
